import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useSubscriptionTrackerStore } from './subscription-tracker.store'; 

export const usePremiumNudgeStore = defineStore('premium-nudge', () => {
	const subscriptionTrackerStore = useSubscriptionTrackerStore();
	const showModal = ref(false);
	const closeCallBack = ref(null);
	const backCallBack = ref(null);

	/**
	 * `onBack` is where checkout's Back button should return to, e.g. the paywall that
	 * opened it. Without one, Back stays inside the modal and shows the plan grid.
	 */
	const setShowModal = (callback, onBack = null) => {
		closeCallBack.value = callback;
		backCallBack.value = onBack;
		showModal.value = true;
		subscriptionTrackerStore.trackModal('onboarding');
	};

	const hideModal = () => {
		showModal.value = false;
		backCallBack.value = null;
		closeCallBack.value();
	};

	/** Back is not a close: hand over to the back target without running the close callback. */
	const goBack = () => {
		const callback = backCallBack.value;
		if (callback === null) {
			return;
		}

		showModal.value = false;
		backCallBack.value = null;
		callback();
	};

	return {
		showModal,

		setShowModal,
		hideModal,
		goBack,
	};
});
